import { hasUnsavedChanges, revertData, save } from 'utils/data';
import { getCurrentDataPath } from 'utils/editor';
import { hasErrors } from 'utils/errors';
import { alert, LeaveConfirmationModal, LeaveWithErrorsModal, showModal } from 'utils/modal';
import { canUser } from 'utils/roles';

/**
 * Prompts the user about any pending changes at `path` before an action that would discard them.
 * Saves or reverts the data depending on their choice, and returns 'CANCEL' if the action should be aborted.
 */
export async function confirmUnsavedChanges(path = getCurrentDataPath()) {
	if (!path || !canUser('write') || !hasUnsavedChanges(path)) return 'CONTINUE';

	const result = await (hasErrors(path)
		? showModal(LeaveWithErrorsModal)
		: showModal(LeaveConfirmationModal, { content: 'You have some unsaved changes. What would you like to do?' }));

	if (result === 'CANCEL') return 'CANCEL';

	if (result === 'SAVE') {
		try {
			await save(path);
		} catch (e) {
			console.error('Error saving data:', e);
			alert('Sorry, an error occurred while saving', { title: 'Error' });
			return 'CANCEL';
		}
	} else {
		revertData(path);
	}

	return result;
}
